import { render } from "./home.vue?vue&type=template&id=36d56022&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "@/styles/home.css?vue&type=style&index=0&id=36d56022&lang=css&scoped=true&external"
import "./home.vue?vue&type=style&index=1&id=36d56022&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d56022"]])

export default __exports__